<template>
  <div class="news-page">
    <div class="sub-hero">
      <div class="sub-hero-inner">
        <div class="sub-breadcrumb"><a href="#/">首页</a> / 展会资讯</div>
        <h1 class="sub-title">展会资讯</h1>
        <p class="sub-subtitle">掌握展会最新动态，第一时间获取重要资讯</p>
      </div>
    </div>
    <div class="sub-body">
      <div class="sub-section">
        <div class="news-loading" v-if="loading">资讯加载中…</div>
        <div class="news-empty" v-else-if="!newsList.length">
          <p>暂无资讯内容</p>
          <a href="#/" class="btn btn-primary">返回首页</a>
        </div>
        <div class="news-list" v-else>
          <a
            v-for="item in newsList"
            :key="item.id"
            class="news-list-item"
            :href="'#/news/' + item.id"
          >
            <div class="news-list-date">
              <div class="news-list-month">{{ item.month }}</div>
              <div class="news-list-day">{{ item.day }}</div>
            </div>
            <div class="news-list-body">
              <h3 class="news-list-title">{{ item.title }}</h3>
              <p class="news-list-desc">{{ item.desc }}</p>
              <span class="news-list-more">阅读全文 →</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleList } from "../api";

export default {
  name: 'NewsList',
  data() {
    return {
      loading: true,
      newsList: [],
    };
  },
  async mounted() {
    const { list } = await getArticleList(0, 20);
    this.newsList = list;
    this.loading = false;
  }
};
</script>

<style scoped>
  .news-page { min-height: 100vh; background: #FBF7F1; color: var(--color-text); }
  .sub-hero {
    background: linear-gradient(135deg, #C25A2D 0%, #ed7b1a 55%, #f3d410 100%);
    color: #fff;
    padding: 140px 32px 96px;
    position: relative;
  }
  .sub-hero::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 30% 20%, rgba(255,255,255,0.25), transparent 55%);
    pointer-events: none;
  }
  .sub-hero-inner { max-width: 1200px; margin: 0 auto; position: relative; }
  .sub-breadcrumb { font-size: 14px; opacity: 0.9; margin-bottom: 24px; letter-spacing: 1px; }
  .sub-breadcrumb a { color: #fff; text-decoration: none; }
  .sub-breadcrumb a:hover { text-decoration: underline; }
  .sub-title { font-family: var(--font-serif); font-size: clamp(36px, 5vw, 56px); font-weight: 900; margin: 0 0 16px; }
  .sub-subtitle { font-size: 18px; opacity: 0.95; margin: 0; max-width: 640px; line-height: 1.8; }
  .sub-body { padding: 80px 32px 120px; }
  .sub-section { max-width: 960px; margin: 0 auto; }

  .news-list { display: flex; flex-direction: column; gap: 20px; }
  .news-list-item {
    display: flex;
    gap: 28px;
    background: #fff;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    padding: 32px;
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
    position: relative;
  }
  .news-list-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 16px 40px rgba(237, 123, 26, 0.12);
    border-color: var(--color-primary-light);
  }
  .news-list-date {
    flex-shrink: 0;
    width: 96px;
    height: 96px;
    background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
    border-radius: var(--radius-md);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: var(--font-serif);
  }
  .news-list-month { font-size: 14px; letter-spacing: 2px; margin-bottom: 4px; opacity: 0.9; }
  .news-list-day { font-size: 34px; font-weight: 900; line-height: 1; }

  .news-list-body { flex: 1; display: flex; flex-direction: column; gap: 10px; }
  .news-list-title { margin: 0; font-size: 22px; font-weight: 700; line-height: 1.5; transition: color 0.2s ease; }
  .news-list-item:hover .news-list-title { color: var(--color-primary); }
  .news-list-desc { margin: 0; color: var(--color-text-light); font-size: 15px; line-height: 1.8; }
  .news-list-more { font-size: 13px; color: var(--color-primary); font-weight: 600; letter-spacing: 1px; }

  .news-loading {
    text-align: center;
    padding: 80px 24px;
    color: var(--color-text-light);
    font-size: 15px;
  }

  .news-empty {
    text-align: center;
    background: #fff;
    border: 1px dashed var(--color-border);
    border-radius: var(--radius-lg);
    padding: 64px 24px;
  }
  .news-empty p { color: var(--color-text-light); margin: 0 0 24px; font-size: 15px; }

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 14px 32px;
    border-radius: 999px;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: none;
    transition: all 0.3s ease;
  }
  .btn-primary {
    background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
    color: #fff;
    box-shadow: 0 8px 24px rgba(237, 123, 26, 0.28);
  }
  .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(237, 123, 26, 0.38); }

  @media (max-width: 640px) {
    .sub-hero { padding: 120px 24px 72px; }
    .sub-body { padding: 48px 24px 80px; }
    .news-list-item { flex-direction: column; gap: 20px; padding: 24px; }
    .news-list-date { width: 100%; height: auto; padding: 12px 0; flex-direction: row; gap: 12px; }
    .news-list-day { font-size: 24px; }
  }
</style>
